module.exports = __webpack_public_path__ + "img/vcn.1796f6be.png";